import { render } from "./createdFolder.vue?vue&type=template&id=24d041b8"
import script from "./createdFolder.vue?vue&type=script&lang=js"
export * from "./createdFolder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__